<template>
  <div class="TPassIconPoint pt-3 mb-5">
    <div :class="['foobar', alertColor, 'text-center']">
      <div class="icon-point" :class="{ 'icon-point-small': isChangeIconWidth }">
        <img
          class="vertical-text-top"
          :src="require('../assets/images/' + messageIcon + '.png')"
          :alt="`${messageIcon}`"
        />
      </div>
      <h6 class="icon-point-title">{{ title }}</h6>
      <h4 v-if="subTitle" class="icon-point-subTitle">{{ subTitle }}</h4>
      <div class="icon-point-message" v-html="msg"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TPassIconPoint',

  props: {
    TPassdetailData: {
      type: Object,
      default: () => {},
    },
    isChangeIconWidth: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      messageIcon: 'fa-check',
      alertColor: 'icon-point-success',
      title: '有效',
      subTitle: '',
      btnName: '',
      btnColor: 'blue',
      msg: '',
      isShowBtn: false,
      apiLoading: false,
    };
  },
  methods: {
    changeMsgIcon(type = 'info', title, message, subTitle, options) {
      console.log('type-', type);
      console.log('subTitle-', subTitle);
      switch (type) {
        case 'success':
        case 'SUCCESS':
          this.messageIcon = 'fa-check';
          break;
        case 'warning':
        case 'ERROR':
        case 'info':
          this.messageIcon = 'fa-exclamation';
          break;
        default:
          this.messageIcon = 'fa-check';
          break;
      }
      this.alertColor = `icon-point-${type}`;
      this.title = title ?? '';
      this.subTitle = subTitle ?? '';
      this.msg = message ?? '';
      if (options && options.isShowBtn === true) {
        this.btnName = options.btnName;
        this.isShowBtn = options.isShowBtn;
        // this.btnColor = `${type}-2`;
      }
    },
    clickBtn() {
      console.log('觸發');
      this.$emit('openTPassDetailContent', this.TPassdetailData, 'msgGoBack');
    },
  },
};
</script>
